<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="btn" @click="handleCategoryModal('add')">+ 添加分类</div>
        <el-table
          :data="categoryList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="classifyName"
            align="center"
            label="分类名称"
          ></el-table-column>
          <el-table-column
            prop="created"
            align="center"
            label="创建时间"
          ></el-table-column>
          <el-table-column prop="orderBy" align="center" label="排序">
            <div slot-scope="scope" @click="changeSortModal(scope.row.id)">
              {{ scope.row.orderBy }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <div slot-scope="scope" style="display: flex">
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleCategoryModal('edit', scope.row)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteCategory(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :visible.sync="visible"
      class="dialog"
      width="400px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "新建" : "编辑") + "分类" }}
      </div>
      <el-form
        ref="form"
        :rules="rules"
        :model="categoryForm"
        class="form"
        label-width="auto"
      >
        <el-form-item label="分类名称:" prop="classifyName" class="form-item">
          <el-input
            size="small"
            placeholder="请输入分类名称"
            class="add-renovation-input"
            style="width: 200px"
            v-model.number="categoryForm.classifyName"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="orderBy" class="form-item">
          <el-input
            size="small"
            placeholder="请输入排序"
            class="add-renovation-input"
            style="width: 200px"
            v-model.number="categoryForm.orderBy"
            type="number"
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
          ></el-input>
          <div class="sort-tip">数值越大，排序越靠前</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改排序弹窗 -->
    <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
      <el-form label-width="60px" size="mini" ref="editSort" inline-message>
        <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
          <el-input v-model="currentSort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="sortShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '奶粉知道分类'
      },
      categoryList: [], // 轮播列表
      rules: {},
      sortShow: false,
      currentSort: 0,
      categoryForm: {
        classifyName: '',
        orderBy: null
      },
      visible: false,
      categoryId: null,
      type: '',
      classifyType: 3
    };
  },
  mounted() {
    // 获取列表
    this.getPlatformCategoryList();
  },
  computed: {},
  methods: {
    // 获取轮播列表
    getPlatformCategoryList() {
      this.loading++;
      this.httpGet(this.$root.getPlatformCategoryList, {
        classifyType: this.classifyType
      }).then(
        (res) => {
          this.loading--;
          this.categoryList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 编辑轮播弹窗
    handleCategoryModal(type, rowData) {
      this.type = type;
      if (type === 'edit') {
        this.categoryId = rowData.id;
        this.categoryForm = {
          classifyName: rowData.classifyName,
          orderBy: rowData.orderBy
        };
      } else {
        this.categoryForm = {
          classifyName: '',
          orderBy: null
        };
        this.$refs.form && this.$refs.form.clearValidate();
      }
      this.visible = true;
    },
    // 删除分类
    deleteCategory(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该分类吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deletePlatformCategory, {
          id,
          classifyType: this.classifyType
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getPlatformCategoryList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 轮播
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url =
            this.type === 'add'
              ? this.$root.addPlatformCategory
              : this.$root.updatePlatformCategory;
          let method =
            this.type === 'add'
              ? 'httpPost'
              : 'httpPut';
          let inputData =
            this.type === 'add'
              ? {
                  ...this.categoryForm,
                  classifyType: this.classifyType
                }
              : {
                  ...this.categoryForm,
                  classifyType: this.classifyType,
                  id: this.categoryId
                };
          this.loading++;
          inputData.orderBy = +inputData.orderBy;
          this[method](url, inputData).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.visible = false;
              this.getPlatformCategoryList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    changeSortModal() {
      // this.sortShow = true;
    },
    saveSort() {}
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 30px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #40B98F;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .form {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 60px;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
}
</style>
